export default {
  EMPTY_LIST: 6003,

  // 检查地址是否可配送
  PREORDER_CHECK_LOGISTICS_ERROR_NO_SUPPORT: 6803017, //地址不支持配送
  PREORDER_CHECK_LOGISTICS_ERROR_LACK_ID: 6813003, //缺少身份证号码
  PREORDER_CHECK_LOGISTICS_ERROR_RESET_POSITION: 6813028,
  PREORDER_CHECK_LOGISTICS_ERROR_LACK_OF_PRODUCT_IN_AREA: 6803031, // 该区域缺少货物
  // 6813028 状态码重复，改用直接引用 返回的文案支持;
  PREORDER_CHECK_LOGISTICS_ERROR_GET_ADDRESS: 6813028, // 使用定位获取更精确的配送地址,

  CARD_CHANNEL_ERROR: 6801101, //卡不适用于当前渠道
  PREORDER_ORDERCHECKPAY_COUPON_ERROR: 1,
  PREORDER_ORDERCHECKPAY_CARD_ERROR: 2,
  PREORDER_ORDERCHECKPAY_BOTH_ERROR: 3,
  PREORDER_ORDERCHECKPAY_FILMCARD_AND_COUPON_CANNOT_BOTH_USE: 500039, //次卡和优惠券不能同时使用
  PREORDER_ORDERCHECKPAY_GIFTCARD_AND_COUPON_CANNOT_BOTH_USE: 500040, // 礼包卡和优惠券不能同时使用
  PREORDER_CARD_AND_COUPON_CANNOT_BOTH_USE: 6811212, // 现金券和卡不能同时使用

  GROUP_MEMBER_NEED_QUERY_AGAIN: 6814009, // 拼团订单处理中，请售后查询

  INSTALLMENT_CHECK_PAY_RESULT_CONTINUE: 6815001, //

  PRODUCTS_NOT_EXIST: 6802002,
  FILM_GB_CODE_GENRATING: 682003,
  FILM_GB_CODE_NOT_SUPPORT: 682004,

  // 活动模板
  ACTIVITY_OUT_LINE: 6809005,
  ACTIVITY_OUT_TIME: 6809004,

}
